import { configureStore } from "@reduxjs/toolkit";
import common from "../reducers/common";
import adminAuthReducer from "../reducers/adminAuthReducer";
import adminSlice from "../reducers/admin/index";
import productSlice from "../reducers/admin/product";
import adminCategorySlice from "../reducers/admin/category";
import adminUser from "../reducers/admin/user";
import userCart from "../reducers/users/user";
import createOrder from "../reducers/users/order";
import couponSlice from "../reducers/admin/coupon";
const store = configureStore({
  reducer: {
    authUser: adminAuthReducer,
    common: common,
    admin: adminSlice,
    product: productSlice,
    category: adminCategorySlice,
    user: adminUser,
    cart: userCart,
    order: createOrder,
    coupon: couponSlice,
  },
});

export default store;
